import { createDCHook, createMutationHook, collapseParams } from '../../client';
import { checkInHouseAvailability, sendHardwareLeads, createOrder } from '../../services/sales/EnecoInHouseService';

export const useEnecoInHouseCheckInHouseAvailability = createDCHook(
  'checkInHouseAvailability',
  checkInHouseAvailability,
  { injectables: [], flattenData: false },
);

export const useEnecoInHouseSendHardwareLeads = createMutationHook(sendHardwareLeads, {
  injectables: [],
  flattenData: false,
});

export const useEnecoInHouseCreateOrder = createMutationHook(
  collapseParams(
    collapseParams(createOrder, 'requestBody', 'data'),
    'data',
    'customer',
    'products',
    'externalReference',
  ),
  {
    injectables: [],
    flattenData: false,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['customer', 'products', 'externalReference'] },
    ],
  },
);
